import {Subject} from 'rxjs';
import {TriggerActionDto} from '../dto/triggerAction.dto';

export class TriggerActionEventsEmitter {
    private readonly triggerAction: Subject<TriggerActionDto> = new Subject();

    triggerActionObservable$ = this.triggerAction.asObservable();

    broadcastActionChanged(triggerActionDto: TriggerActionDto) {
        this.triggerAction.next(triggerActionDto);
    }
}
